module.exports = __webpack_public_path__ + "img/meme-drake.016db000.png";